import { z } from 'zod';
import { providerSchema } from './provider';

export const statementSchema = z.object({
  id: z.string(),
  providerID: z.string(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  reportPath: z.string(),
  statementPath: z.string(),
  siteID: z.uuid(),
  remittanceID: z.guid().nullable().optional(),
  provider: z.lazy(() => providerSchema.optional()),
  totalAmount: z.string().nullable(),
});
